import { NavigationAction } from '@react-navigation/native';
import { useFocusEffect } from '@react-navigation/native';
import { useCallback, useEffect } from 'react';
import { PatientList } from '@/components/PatientList/';
import { useSidebarAnimation } from '@/components/ui/therapist/CollapsibleSidebar/SidebarAnimationContext';

interface HomeTherapistProps {
  navigation: any;
}

export function HomeTherapist({ navigation }: HomeTherapistProps) {
  const { setAppTitle } = useSidebarAnimation();

  useEffect(() => {
    navigation.addListener(
      'beforeRemove',
      (e: { data: { action: NavigationAction } }) => {
        navigation.dispatch(e.data.action);
      },
    );
  }, []);

  useFocusEffect(
    useCallback(() => {
      setAppTitle('Patient:innen');
    }, [setAppTitle]),
  );

  return <PatientList />;
}
